import { useTranslation } from "react-i18next";
import { Divider, Form, Icon, Modal } from "semantic-ui-react";

import { createFormHelper } from "lib/Form";

import type { TagFormPayload } from "modules/TagsDashboard/components/TagModal/hooks";

type TagFormProps = {
  isEdit: boolean;
  isPending: boolean;
  onClose: () => void;
};

const FormHelper = createFormHelper<TagFormPayload>();

export const TagForm = ({ isEdit, isPending, onClose }: TagFormProps) => {
  const { t } = useTranslation();
  const { watch, formState } = FormHelper.useFormContext();

  const name = watch("name");

  return (
    <>
      <Modal.Header className="padding-container">
        <div className="header-title">{isEdit ? t("v8_edit_tag", "Edit Tag") : t("v8_add_new_tag", "Add New Tag")}</div>
      </Modal.Header>
      <Divider fitted />

      <Modal.Content className="padding-container">
        <div className="tag-form-row">
          <Form.Field error={formState.isSubmitted && !name.trim()} className="tag-name-field">
            <FormHelper.Field.Input name="name" inputProps={{ placeholder: t("v8_tag_name", "Tag name") }} />
          </Form.Field>
          <FormHelper.Field.Checkbox name="is_system" label={t("v8_system", "System")} formFieldProps={{ className: "tag-for-system-field" }} />
          <FormHelper.Field.ColorPicker name="color" formFieldProps={{ className: "tag-color-field" }} />
        </div>
      </Modal.Content>
      <Divider fitted />

      <Modal.Actions className="padding-container">
        <div className="action-buttons-container">
          <div className="right-buttons">
            <Form.Button type="button" className="light" onClick={onClose}>
              {t("v8_cancel", "Cancel")}
              <Icon className="xmark" />
            </Form.Button>
            <Form.Button type="submit" color="green" disabled={isPending} loading={isPending}>
              {t("v8_save", "Save")}
              <Icon className="check" />
            </Form.Button>
          </div>
        </div>
      </Modal.Actions>
    </>
  );
};
